import React from 'react';
import "./Style.css";

const TablePreview = ({ pageData }) => {

    return (
        <div className={`w-[100px] ms-auto h-[180px] rounded-xl border-2 overflow-hidden flex flex-col`}
            style={{
                fontFamily: pageData?.textOption?.font,
                backgroundColor: pageData?.backgroundOption?.color ? pageData?.backgroundOption?.color : pageData?.backgroundOption?.image ? 'unset' : '#ECECF2',
                backgroundRepeat: 'no-repeat',
                backgroundImage: pageData?.backgroundOption?.gradient?.length ? `linear-gradient(${pageData?.backgroundOption?.gradientAngle} ,${pageData?.backgroundOption?.gradient[0]}, ${pageData?.backgroundOption?.gradient[1]})` : pageData?.backgroundOption?.image ? `url(${(pageData?.backgroundOption?.image)})` : 'unset',
                backgroundSize: pageData?.backgroundOption?.image ? 'cover' : 'unset',
                backgroundPosition: pageData?.backgroundOption?.image ? 'center' : 'unset',
            }}>

            {pageData?.layout == 1 && <Head1 pageData={pageData} />}
            {pageData?.layout == 2 && <Head2 pageData={pageData} />}
            {pageData?.layout == 3 && <Head3 pageData={pageData} />}
            {pageData?.layout == 4 && <Head4 pageData={pageData} />}
            {pageData?.layout == 5 && <Head5 pageData={pageData} />}

            <div className="flex flex-col gap-3 p-3 flex-1">
                {pageData?.socialLinks?.length > 0 && <div className={`flex justify-center gap-1 flex-wrap ${pageData?.socialLinksOption?.placement == "top" ? 'order-1' : 'order-2'}`}>
                    {
                        pageData?.socialLinks?.map((item) => {
                            return (
                                <a key={item.sortId} href={item.channelLink} target='_blank' rel='noopener noreferrer'>
                                    <img src={item?.icon} alt="" className='h-3 object-contain' />
                                </a>
                            )
                        })
                    }
                </div>}
                <div className={`flex flex-1 flex-col !gap-4 ${pageData?.socialLinksOption?.placement == "top" ? 'order-2' : 'order-1'}`}>
                    <div className='px-2 py-1 flex items-center justify-center gap-3' style={{
                        backgroundColor: pageData?.blocksOption?.background,
                        borderRadius: pageData?.blocksOption?.borderRadius,
                        boxShadow: pageData?.blocksOption?.shadowSize == "none" ? 'none' : `3px 6px ${pageData?.blocksOption?.shadowSize == "medium" ? 2 : 10}px 0px rgba(0,0,0,0.58)`,
                        borderWidth: pageData?.blocksOption?.border,
                        borderStyle: 'solid',
                        borderColor: pageData?.blocksOption?.borderColor
                    }}>
                        <div className='w-full text-center py-0.5'>

                        </div>
                    </div>
                </div>
                <div className="flex order-3 items-center justify-center">
                    <div className="aspect-square bg-white flex items-center justify-center rounded-full p-0.5 shadow-md">
                        <img src={process.env.PUBLIC_URL + "/images/icon-logo.png"} className='h-2' alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TablePreview;

export const Head1 = ({ pageData }) => {
    return (
        <div className='px-1 py-2 text-center'>
            {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-6 aspect-square ms-auto me-auto rounded-full object-cover' /> : <div className='h-6 aspect-square ms-auto bg-[#B1B3C8] me-auto rounded-full object-cover'></div>}
            {<p className='mt-2 mb-1 text-[10px] font-bold capitalize' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title ?? "Welcome"}</p>}
            {pageData?.description && <p className='mb-1 text-[8px] font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
        </div>
    )
}

export const Head2 = ({ pageData }) => {
    return (
        <div className='h-max'>
            <div style={{
                clipPath: 'polygon(0% 0%, 0% 100%, 0.818% 99.342%, 0.818% 99.342%, 10.507% 92.4%, 20.353% 87.015%, 30.317% 83.189%, 40.358% 80.92%, 50.437% 80.209%, 60.514% 81.054%, 70.549% 83.456%, 80.501% 87.415%, 90.331% 92.929%, 100% 100%, 100% 0%, 0% 0%)', width: '100%', height: '2.8rem',
                backgroundColor: pageData?.headerOption?.color ? pageData?.headerOption?.color : '#d4d4d4',
                backgroundImage: pageData?.headerOption?.gradient?.length ? `linear-gradient(${pageData?.headerOption?.gradientAngle} ,${pageData?.headerOption?.gradient[0]}, ${pageData?.headerOption?.gradient[1]})` : pageData?.headerOption?.image ? `url(${(pageData?.headerOption?.image)})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }} >
            </div>
            <div className="relative mt-[-20px] text-center">
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-6 aspect-square ms-auto me-auto rounded-full object-cover' /> : <div className='h-6 aspect-square ms-auto bg-[#B1B3C8] me-auto rounded-full object-cover'></div>}
                {pageData?.title && <p className='mt-2 mb-1 text-[10px] font-bold capitalize' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.description && <p className='mb-1 text-[8px] font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
            </div>
        </div>

    )
}

export const Head3 = ({ pageData }) => {
    return (
        <div className=''>
            <div className='h-12 w-full' style={{
                backgroundColor: pageData?.headerOption?.color ? pageData?.headerOption?.color : pageData?.headerOption?.image ? 'unset' : '#d4d4d4',
                backgroundImage: pageData?.headerOption?.gradient?.length ? `linear-gradient(${pageData?.headerOption?.gradientAngle} ,${pageData?.headerOption?.gradient[0]}, ${pageData?.headerOption?.gradient[1]})` : pageData?.headerOption?.image ? `url(${(pageData?.headerOption?.image)})` : 'unset',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}>
            </div>
            <div className="relative mt-[-10px] text-left px-2">
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-6 aspect-square me-auto rounded-full object-cover' /> : <div className='h-6 aspect-square bg-[#B1B3C8] rounded-full object-cover'></div>}
                {pageData?.title && <p className='mt-2 mb-1 text-[10px] font-bold capitalize' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.description && <p className='mb-1 text-[8px] font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
            </div>
        </div>

    )
}

export const Head4 = ({ pageData }) => {
    return (
        <div className=''>
            <div className='h-12 w-full text-center pt-4' style={{
                backgroundColor: pageData?.headerOption?.color ? pageData?.headerOption?.color : pageData?.headerOption?.image ? 'unset' : '#d4d4d4',
                backgroundImage: pageData?.headerOption?.gradient?.length ? `linear-gradient(${pageData?.headerOption?.gradientAngle} ,${pageData?.headerOption?.gradient[0]}, ${pageData?.headerOption?.gradient[1]})` : pageData?.headerOption?.image ? `url(${(pageData?.headerOption?.image)})` : 'unset',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }} >
            </div>
            <div className="relative mt-[-15px] text-center">
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-8 aspect-square ms-auto me-auto rounded-full object-cover' /> : <div className='h-8 aspect-square ms-auto bg-[#B1B3C8] me-auto rounded-full object-cover'></div>}
                {pageData?.title && <p className='text-[10px] font-bold capitalize whitespace-nowrap mt-2 mb-2' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.description && <p className='mb-1 mt-1 text-[8px] font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p>}
            </div>
        </div>

    )
}

export const Head5 = ({ pageData }) => {
    return (
        <div className='px-1 py-2'>
            <div className="flex items-center">
                {pageData?.title && <p className='text-[10px] font-bold capitalize mb-0' style={{ color: pageData?.textOption?.titleColor ? pageData?.textOption?.titleColor : '#070707' }}>{pageData?.title}</p>}
                {pageData?.image ? <img src={pageData?.image && (pageData?.image)} alt="" className='h-6 aspect-square ms-auto rounded-full object-cover' /> : <div className='h-6 aspect-square ms-auto bg-[#B1B3C8] rounded-full object-cover'></div>}
            </div>
            {pageData?.description && <div className='mt-3 border-t-[1px] border-b-[1px] border-[#686C8F] py-2'> <p className='mb-0 text-[8px] font-medium' style={{ color: pageData?.textOption?.descriptionColor ? pageData?.textOption?.descriptionColor : '#526281' }}>{pageData?.description}</p></div>}
        </div>

    )
}